import { combineReducers } from 'redux';
import {
  SET_USER_INFO,
  SET_USER_LOADING,
  SET_BUILD_INFO,
  SET_DAL_OPTIONS,
  SET_STUDY_STATUS_OPTIONS,
  SET_ORGANISM_OPTIONS,
  SET_ORGANIZATIONS_OPTIONS,
  SET_SPONSORS_OPTIONS,
  SET_DATA_TYPE_OPTIONS,
  SET_EXPOSURE_TYPE_OPTIONS,
  SET_TRUTH_DATA_OPTIONS,
  SET_STUDY_SEARCH_QUERY,
  SET_STUDY_SEARCH_RESULTS,
  SET_TAGS,
  SET_MODEL_TYPES_OPTIONS,
  SET_MODEL_EXPOSURE_TYPES_OPTIONS,
  SET_PAGE_INFO,
  SET_TOOLS_PAGE,
  SET_FEATURE_COHORT,
  SET_FEATURE_STUDYCARD,
  SET_FEATURE_ANALYST_WORKBENCH,
  SET_PAGE_LOADING,
  SET_THEME
} from './actions';

function userInfo(state = {}, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        ...action.userInfo
      }
    case SET_USER_LOADING:
      return {
        ...state,
        user_loading: action.userLoading
      }
    default: 
      return state;
  }
}

function studyRegistrationOptions(state = {}, action) {
  switch (action.type) {
    case SET_DAL_OPTIONS:
      return {
        ...state,
        dal_options: action.options
      }
    case SET_STUDY_STATUS_OPTIONS:
      return {
        ...state,
        study_status_options: action.options
      }
    case SET_ORGANISM_OPTIONS:
      return {
        ...state,
        organism_options: action.options
      }
    case SET_ORGANIZATIONS_OPTIONS:
      return {
        ...state,
        collab_org: action.options
      }
    case SET_SPONSORS_OPTIONS:
      return {
        ...state,
        sponsor_options: action.options
      }
    case SET_DATA_TYPE_OPTIONS:
      return {
        ...state,
        data_type: action.options
      }
    case SET_EXPOSURE_TYPE_OPTIONS:
      return {
        ...state,
        exposure_type: action.options
      }
    case SET_TRUTH_DATA_OPTIONS:
      return {
        ...state,
        truth_data: action.options
      }
    case SET_TAGS:
      return {
        ...state,
        tags: action.tags
      }
    default: 
      return state;
  }
}

function algorithmRegistrationOptions(state = {}, action) {
  switch (action.type) {
    case SET_MODEL_TYPES_OPTIONS:
      return {
        ...state,
        model_types: action.options
      }
    case SET_MODEL_EXPOSURE_TYPES_OPTIONS:
      return {
        ...state,
        model_exposure_types: action.options
      }
    default: 
      return state;
  }
}

function studySearch(state = {}, action) {
  switch (action.type) {
    case SET_STUDY_SEARCH_QUERY:
      return {
        ...state,
        query: action.query
      }
    case SET_STUDY_SEARCH_RESULTS:
      return {
        ...state,
        result: action.results
      }
    default: 
      return state;
  }
}

function tags(state = {}, action) {
  switch (action.type) {
    case SET_TAGS:
      return action.tags;
    default: 
      return state;
  }
}

function buildInfo(state = '', action) {
  switch (action.type) {
    case SET_BUILD_INFO:
      return action.buildInfo;
    default:
      return state;
  }
}

function pageInfo(state ='', action){
  switch (action.type) {
    case SET_PAGE_INFO:
      return {
        ...state,
        ...action.pages
      }
    case SET_TOOLS_PAGE:
      return {
        ...state,
        tools_page: action.toolsPage
      }
    case SET_FEATURE_COHORT:
      return {
        ...state,
        feature_cohort: action.feature_cohort
      }
    case SET_FEATURE_STUDYCARD:
      return {
        ...state,
        feature_studycard_v2: action.feature_studycard_v2
      }
    case SET_FEATURE_ANALYST_WORKBENCH:
      return {
        ...state,
        feature_analyst_workbench: action.feature_aw
      }
    case SET_PAGE_LOADING:
      return {
        ...state,
        page_loading: action.pageLoading
      }
    default:
      return state;
  }
}

function theme(state ='', action){
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        theme: action.theme
      }
    default:
      return state;
  }
}

const combinedReducers = combineReducers({
  userInfo,
  studyRegistrationOptions,
  algorithmRegistrationOptions,
  studySearch,
  tags,
  buildInfo,
  pageInfo,
  theme,
});

export default combinedReducers;